import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../enums';

const Component = () => import('./LocalMenuGroupDetails.vue');

export default {
  path: buildChildURL(LocalMenuGroupRoutePathNames.ID),
  name: LocalMenuGroupRouteNames.LOCAL_MENU_DETAILS,
  component: Component,
} as RouteRecordRaw;
